export default __webpack_public_path__ + "static/media/pilot.632aeac9.jpg";